export const nhomHang = {
  sections: {
    list: { title: '商品组' },
    tree: { title: '商品组 — 树形' },
    viewBasic: '基本信息',
    viewLinkage: '父级',
    viewStatus: '状态',
    viewAudit: '时间',
  },
  hints: {
    organize: '按层级组织商品分组，便于批量筛选和选择商品。',
    description: '按品类、特性、功能管理商品。',
  },
  fields: {
    code: '编码',
    name: '名称',
    description: '描述',
    parentGroup: '父组',
    level: '层级',
    productCount: '商品数',
    status: '状态',
    onOffAction: '开关',
    listOrder: '排序',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
  },
  status: {
    active: '启用',
    inactive: '停用',
    all: '全部',
  },
  filters: {
    all: '全部',
    groupTreeSection: '货品分组',
    treeAll: '全部分组',
    treeSearch: '搜索分组',
    statusSection: '状态',
    relatedSection: '关联',
    relatedHint: '打开货品列表，为商品指定分组。',
    openProducts: '货品列表',
    maNhomCha: '父组编码',
    sortSection: '排序',
  },
  trangThai: {
    DANG_HOAT_DONG: '运营中',
    NGUNG_HOAT_DONG: '已暂停',
  },
  placeholders: {
    searchParentNhomHang: '选择父级',
    searchCodeName: '按编码、名称',
    maAuto: '自动生成：NHTBPC001，二级 NHTBPC001-01，三级 NHTBPC001-01-01',
    tenNhom: '请输入分组名称',
  },
  messages: {
    noData: '暂无数据',
    listSummary: '共 {count} 条',
    listSummaryKiot: '按筛选条件共 {count} 个分组',
    saving: '保存中…',
    createSuccess: '已创建商品组',
    updateSuccess: '已更新商品组',
    deleteSuccess: '已删除商品组',
    deleteError: '无法删除商品组',
    deleteSelected: '删除已选 ({count})',
    selectedCount: '已选：{count}',
    bulkDeleteConfirm: '删除已选的 {count} 个分组？（逐条调用删除 API；有子分组时需先删子级。）',
    bulkDeleteSuccess: '已删除 {count} 个分组',
    bulkDeletePartial: '已删除 {ok}/{total}，{failed} 个无法删除。',
    bulkDeleteError: '批量删除失败',
    bulkDeleteNoneSelected: '未选择任何分组',
    loadError: '加载失败',
    confirmDelete: '确定删除「{name}」吗？',
    searchPlaceholder: '按编码或名称筛选…',
    reorderError: '无法更新排序',
    exportComingSoon: '商品组导出功能即将上线',
  },
  import: {
    description: '选择 Excel (.xlsx) 文件：组编码、名称、状态、父组编码。',
    success: '商品组导入成功',
    failed: '商品组导入失败',
    noData: '文件中没有有效数据行',
    noSheet: 'Excel 文件没有数据工作表',
  },
  actions: {
    addChild: '添加子级',
    moveUp: '上移',
    moveDown: '下移',
    toggleStatus: '切换状态',
    createInline: '新建',
  },
  tabs: {
    info: '信息',
    products: '商品',
  },
  products: {
    hint: '商品',
    export: '导出',
    create: '新建商品',
    empty: '该组暂无商品',
    loadError: '无法加载商品',
    code: '商品编码',
    name: '商品名称',
    unit: '单位',
    price: '售价',
    stock: '库存',
  },
  titles: {
    addNew: '新增商品组',
    addQuick: '快速新增',
    edit: '编辑商品组',
    detail: '商品组详情',
  },
  viewModes: {
    list: '列表',
    tree: '树形',
    level: '层级表',
  },
  levelTable: {
    lv1: '一级编码',
    lv2: '二级编码',
    lv3: '三级编码',
    lv4: '四级编码',
  },
}
